import React from 'react';

const Privacy = () => {
  return (
    <div className="container section">
      <div style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: '#fff', padding: '3rem', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
        <h1 className="section-title" style={{ marginBottom: '2rem', textAlign: 'left' }}>Privacy Policy</h1>
        
        <div style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563' }}>
          <p style={{ marginBottom: '1.5rem', fontSize: '0.9rem', color: '#6b7280' }}>Last updated: January 1, 2026</p>

          <p style={{ marginBottom: '1.5rem' }}>
            Sunshine Travels ("we", "us", or "our") respects your privacy and is committed to protecting your personal data. This privacy policy explains how we collect, use, and safeguard your information when you visit our website or use our services.
          </p>

          <h3 style={{ fontSize: '1.3rem', color: '#111', marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold' }}>Information We Collect</h3>
          <p style={{ marginBottom: '1.5rem' }}>
            We may collect personal identification information from you in a variety of ways, including, but not limited to, when you visit our site, fill out a form, make a booking, or subscribe to our newsletter. The information we may collect includes your name, email address, phone number, and payment details.
          </p>

          <h3 style={{ fontSize: '1.3rem', color: '#111', marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold' }}>How We Use Your Information</h3>
          <p style={{ marginBottom: '1.5rem' }}>
            We use the information we collect primarily to:
            <br/>- Process your bookings and manage your account.
            <br/>- Communicate with you regarding your trip details.
            <br/>- Improve our website and customer service.
            <br/>- Send periodic emails containing travel updates, promotions, and news (only if you have opted in).
          </p>

          <h3 style={{ fontSize: '1.3rem', color: '#111', marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold' }}>Data Protection</h3>
          <p style={{ marginBottom: '1.5rem' }}>
            We adopt appropriate data collection, storage, and processing practices and security measures to protect against unauthorized access, alteration, disclosure, or destruction of your personal information and transaction data stored on our site.
          </p>

          <h3 style={{ fontSize: '1.3rem', color: '#111', marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold' }}>Sharing Your Information</h3>
          <p style={{ marginBottom: '1.5rem' }}>
            We do not sell, trade, or rent your personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information with our business partners and trusted affiliates. We may also share data with third-party service providers (like payment processors) solely for the purpose of operating our business and providing services to you.
          </p>

          <h3 style={{ fontSize: '1.3rem', color: '#111', marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold' }}>Cookies</h3>
          <p style={{ marginBottom: '1.5rem' }}>
            Our website uses "cookies" to enhance user experience. You may choose to set your web browser to refuse cookies, or to alert you when cookies are being sent. If they do so, note that some parts of the site may not function properly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
